import { FC } from 'react';
import { useLocation } from 'react-router-dom';

import { useAuthenticated } from 'hooks/useAuthenticated';

import { Stepper } from 'components/_basic/Stepper/Stepper';
import { AuthModalView } from 'components/AuthModals';

import {
  RegistrationContextProvider,
  useRegistrationContext,
} from './RegistrationContextProvider/RegistrationContextProvider';
import { EnterCodeStep } from './RegistrationForms/EnterCodeStep/EnterCodeStep';
import { PersonalInfoStep } from './RegistrationForms/PersonalInfoStep/PersonalInfoStep';

interface IProps {
  isModalOpened: boolean;
  handleModalClose(): void;
}

export const Registration: FC<IProps> = ({ isModalOpened, handleModalClose }) => {
  const stepArray = [PersonalInfoStep, EnterCodeStep];
  const { isAuthenticated } = useAuthenticated();
  const location = useLocation();
  const isSubscriptionPage = location.pathname === '/subscription-plans';

  const closeFunction = !isAuthenticated && !isSubscriptionPage ? () => null : handleModalClose;

  return (
    <RegistrationContextProvider isModalOpened={isModalOpened}>
      <AuthModalView isModalOpened={isModalOpened} onModalClose={closeFunction}>
        <Stepper useModalContext={useRegistrationContext} stepForms={stepArray} onClose={handleModalClose} />
      </AuthModalView>
    </RegistrationContextProvider>
  );
};
